export default __webpack_public_path__ + "static/media/purchase_flow.5daaa77c.png";